import { render } from "./SimplifiedCriterion.vue?vue&type=template&id=1dd8c876&scoped=true"
import script from "./SimplifiedCriterion.vue?vue&type=script&lang=js"
export * from "./SimplifiedCriterion.vue?vue&type=script&lang=js"

import "./SimplifiedCriterion.vue?vue&type=style&index=0&id=1dd8c876&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd8c876"]])

export default __exports__